import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { Alert, Intent } from '@blueprintjs/core';
import Pagination from 'components/Pagination';
import Footer from 'components/Footer';
import Toast from 'helpers/toaster';
import * as DataList from 'components/DataList';

// Layout shared by the list and its loading skeleton (pages/frequency/index.js).
export const FREQUENCY_COLUMNS = [
  { area: 'title', label: 'Title', width: 'minmax(200px, 1fr)', bone: 'single' },
  { area: 'actions', label: '', width: '72px', bone: 'none' },
];

export const FREQUENCY_CARDS = {
  columns: 'minmax(0, 1fr) auto',
  areas: ['title actions'],
};

export const FREQUENCY_MIN_TABLE_WIDTH = 360;

@inject('store', 'clientStore', 'frequencyStore', 'viewStore') @observer
class FrequencyTable extends Component {
  @observable isDeleteDialogVisible = false;
  @observable service;

  onPaginationChange(newPage) {
    let {
      viewStore: {
        frequencySearch
      }
    } = this.props;
    this.props.viewStore.frequencySearch = {
      ...frequencySearch,
      page: newPage
    };
    this.props.viewStore.frequencies();
  }

  // Empty list's "Clear search": back to all frequencies, page 1.
  clearSearch() {
    const { viewStore } = this.props;
    viewStore.frequencySearch = { ...viewStore.frequencySearch, term: '*', page: 1 };
    viewStore.bumpListFilters();
    viewStore.frequencies();
  }

  handleDeleteCancel() {
    this.isDeleteDialogVisible = false;
  }

  handleDeleteConfirm() {
    this.isDeleteDialogVisible = false;
    this.props.frequencyStore.deleteFrequency(this.service)
      .then(this.onSuccessfulDeleteFrequency.bind(this))
      .catch(this.onFailDeleteFrequency.bind(this))
  }

  onSuccessfulDeleteFrequency(response) {
    Toast.show({ icon: 'thumbs-up', message: 'Frequency deleted', intent: Intent.SUCCESS })
    this.service = null;
    this.isDeleteDialogVisible = false;
  }

  onFailDeleteFrequency(error) {
    this.isDeleteDialogVisible = false;
    Toast.show({ icon: 'warning-sign', message: 'Unable to delete frequency', intent: Intent.DANGER })
  }

  confirmDelete(frequency) {
    this.service = frequency;
    this.isDeleteDialogVisible = true;
  }

  render() {
    let {
      viewStore,
      frequencyStore: {
        frequencies: {
          objects,
          meta
        }
      }
    } = this.props;
    const { frequencySearch } = viewStore;
    const term = frequencySearch.term && frequencySearch.term !== '*' ? frequencySearch.term : '';

    if (objects.length === 0) {
      return (
        <DataList.Empty
          noun="frequencies"
          term={term}
          onClearFilters={this.clearSearch.bind(this)}
          extraAction={!term && { label: 'Add frequency', icon: 'plus', onClick: () => viewStore.frequencyAdd(), primary: true }}
        />
      );
    }
    return (
      <React.Fragment>
        <Footer>
          <div className="bp3-navbar-group bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>
        <DataList.List
          columns={FREQUENCY_COLUMNS}
          cards={FREQUENCY_CARDS}
          minTableWidth={FREQUENCY_MIN_TABLE_WIDTH}
          total={meta.total_records || objects.length}
          noun="frequencies"
          note={DataList.sortNote(frequencySearch.order)}
        >
          {objects.map((frequency) => {
            const attributes = frequency.attributes;
            return (
              <DataList.Row key={frequency.id}>
                <DataList.Cell area="title">
                  <DataList.RowLink
                    href={`/dashboard/frequency/${attributes.id}/show`}
                    label={`Frequency ${attributes.title}`}
                  >
                    {attributes.title}
                  </DataList.RowLink>
                </DataList.Cell>
                <DataList.Cell area="actions">
                  <DataList.Actions
                    items={[
                      { icon: 'edit', label: 'Edit frequency', onClick: () => viewStore.frequencyShow({ uuid: attributes.id }) },
                      { icon: 'trash', label: 'Delete frequency', intent: 'danger', onClick: () => this.confirmDelete(frequency) },
                    ]}
                  />
                </DataList.Cell>
              </DataList.Row>
            );
          })}
        </DataList.List>
        <Alert
          cancelButtonText="Cancel"
          confirmButtonText="Delete"
          icon="trash"
          intent={Intent.DANGER}
          isOpen={this.isDeleteDialogVisible}
          onCancel={this.handleDeleteCancel.bind(this)}
          onConfirm={this.handleDeleteConfirm.bind(this)}
        >
          <p>Deleting this frequency can't be undone.</p>
          <p>Are you sure you want to delete it?</p>
        </Alert>

        <Footer>
          <div className="bp3-navbar-group bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>

      </React.Fragment>
    )
  }

}

export default FrequencyTable;
